import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import React, { useCallback } from 'react';
import DashboardFiRow from './DashboardFiRow.jsx';

const DashboardFiTable = ({
  datas,
  profile,
  page,
  setPage,
  limit,
  isCurrentRefund,
}) => {
  const fields = [
    'Date de la demande',
    'Référence',
    'Commande',
    'Moyen de paiement',
    'Client',
    'Justification',
    'Montants',
    'Auteur',
    'Statut',
    isCurrentRefund ? 'Traitement' : 'Date de traitement',
  ];

  const handleChangePage = useCallback(
    (event, newPage) => {
      setPage(newPage);
    },
    [limit, datas]
  );

  return (
    <Box sx={{ paddingTop: 3 }}>
      <TableContainer component={Paper} sx={{ borderRadius: 0 }}>
        <Table>
          <TableHead>
            <TableRow>
              {fields.map((field, index) => (
                <TableCell key={index} align="center" sx={{ borderBottom: 1 }}>
                  {field}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {datas?.data?.map((item) => (
              <DashboardFiRow
                key={item?._id}
                refund={item}
                profile={profile}
                isCurrentRefund={isCurrentRefund}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[limit]}
        component="div"
        count={datas?.totalCount || 0}
        rowsPerPage={limit}
        page={page}
        onPageChange={handleChangePage}
      />
    </Box>
  );
};

export default DashboardFiTable;
